import OSvg from './OSvg'

export default OSvg
